export default __webpack_public_path__ + "static/media/innovation.2668f314.png";